export const ourService = {
    title: 'Our Services',
    description: 'We Empower Businesses With Cutting-Edge Technologies And Drive Tangible Results.'
};
